import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function KidsTaekwondoNarrative() {
  return <section className="py-24 bg-off-white" data-id="element-2220">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2221">
        <p className="text-sm font-bold uppercase tracking-wide text-storm-red mb-3" data-id="element-2222">
          Farmington Hills / Commerce / Walled Lake / Wixom / Novi Martial Arts
        </p>
        <h2 className="text-4xl md:text-5xl text-ink mb-8 leading-tight" data-id="element-2223">
          Hands Down The Best Decision You'll Make All Year
        </h2>
        <div className="flex flex-col gap-5 mb-10 text-lg text-gray-warm leading-relaxed" data-id="element-2224">
          <p className="m-0" data-id="element-2225">
            Are you a parent in Farmington Hills, Commerce, Walled Lake, Wixom,
            or Novi looking for a program that teaches your child self-defense
            while also building grit and mental toughness for life's challenges?
          </p>
          <p className="m-0" data-id="element-2226">
            Hi, I'm Shane Merem — owner and head coach at Storm Taekwondo. No
            matter your child's age or experience level, there is a clear,
            proven way to help them build self-discipline, respect, and real
            character. Storm Taekwondo is built around exactly that.
          </p>
        </div>
        <div className="mb-10" data-id="element-2227">
          <h3 className="text-2xl text-ink mb-5" data-id="element-2228">
            After joining Storm Taekwondo, your child will:
          </h3>
          <ul className="flex flex-col gap-3" data-id="element-2229">
            {['Build the discipline and focus that pays off in martial arts and in everyday life.', 'Learn the importance of setting goals — and the ability to surpass them.', 'Develop the awareness and confidence to stand up for themselves when needed.', 'Treat siblings, classmates, and parents with more kindness and respect.', 'Grow more affectionate, caring, and connected with their family.', 'Develop the tools to grow into a successful adult with a healthy mind, body, and spirit.'].map((b, idx) => <li key={idx} className="flex items-start gap-3 text-lg text-gray-warm leading-relaxed" data-id="element-2230">
                <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-2231" />
                <span data-id="element-2232">{b}</span>
              </li>)}
          </ul>
        </div>
        <div className="bg-paper border-2 border-storm-red rounded-3xl py-12 px-8 text-center my-12" data-id="element-2233">
          <p className="text-2xl md:text-3xl text-storm-red font-bold leading-snug m-0 max-w-xl mx-auto" data-id="element-2234">
            Give your child a program that builds real skills and real
            character.
          </p>
        </div>
      </div>
    </section>;
}